import { useState } from 'react'
import { Mail } from 'lucide-react'

export default function NewsletterSignup() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    setStatus('Thank you for subscribing!')
    setEmail('')
    setTimeout(() => setStatus(''), 3000)
  }

  return (
    <div className="bg-gradient-to-r from-primary to-blue-900 text-white section-padding">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <Mail className="w-16 h-16 mx-auto mb-6 text-secondary" />
          <h2 className="heading-2 text-white mb-4">Stay Connected</h2>
          <p className="text-xl mb-8">
            Subscribe to our newsletter for updates on programs, events, and inspirational content from Rev. Doc. Doreen Mwendesi.
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="flex-1 px-6 py-4 rounded-lg text-primary focus:outline-none focus:ring-4 focus:ring-secondary"
              aria-label="Email address"
            />
            <button type="submit" className="btn-primary whitespace-nowrap">
              Subscribe Now
            </button>
          </form>
          {status && (
            <p className="mt-4 text-secondary font-semibold">{status}</p>
          )}
        </div>
      </div>
    </div>
  )
}
